export default {
    message_template_create_success_message: "Se ha creado la plantilla de mensaje",
    message_template_create_title: "Crear plantilla de mensaje",
    message_template_edit_success_message: "La plantilla de mensaje ha sido editado",
    message_template_edit_title: "Editar la plantilla de mensaje",
    message_template_name: "Nombre",
    message_template_status: "Estado",
    message_template_active: "Activo",
    message_template_inactive: "Inactivo",

    message_template_code_forgot_password: "Olvidé la contraseña",
    message_template_code_verify_email: "Verificar correo electrónico",
    message_template_code_verify_email_legacy: "Verificar correo electrónico legado",
    message_template_language: "Idioma",
    message_template_template: "Plantilla",
    message_template_email_from: "Correo electrónico de",
    message_template_email_subject: "Asunto del correo electrónico",
    message_template_email_body: "Cuerpo del correo electrónico",
    message_template_create_error_message: "Error al crear la plantilla de mensaje",
    message_template_create_duplicate_code: "La plantilla de mensaje ya existe con el mismo código/idioma",
    message_template_create_missing_template_fields: "Todos los campos de la plantilla deben añadirse al cuerpo del correo electrónico",
}